var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCreated = function SvgCreated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.8658 14 14 10.8675 14 7C14 3.1325 10.8658 0 7 0C3.13425 0 0 3.1325 0 7C0 10.8675 3.13425 14 7 14ZM10.3749 5.4162C10.5875 5.12745 10.5227 4.71616 10.2296 4.49741C9.93648 4.28741 9.52613 4.3488 9.31263 4.6463L6.26498 8.83759L4.62003 7.19247C4.36365 6.93872 3.94885 6.93872 3.69247 7.19247C3.4361 7.44622 3.4361 7.86628 3.69247 8.12003L5.87997 10.3075C6.0156 10.4475 6.20377 10.5087 6.39539 10.5C6.58614 10.4825 6.762 10.3862 6.87487 10.2287L10.3749 5.4162Z",
    fill: "currentColor"
  })));
};
export default __webpack_public_path__ + "assets/52764e458b87ec15d27d5e18e7156627.svg";
export { SvgCreated as ReactComponent };


// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/Status/assets/icons/created.svg